module.exports = __webpack_public_path__ + "static/media/Demo Housing.cb72f6e1.pdf";